<template>
  <b-modal
    ref="modal"
    title="Upload"
    ok-title="Upload"
    size="lg"
    :ok-disabled="!files.length || submitting"
    :cancel-disabled="submitting"
    :no-close-on-backdrop="submitting"
    :no-close-on-esc="submitting"
    :hide-header-close="submitting"
    @ok="ok"
    @hide="closeHandler"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <p
      v-if="error"
      role="alert"
      class="text-danger"
    >
      {{ error }}
    </p>
    <Vue2Dropzone
      id="uploadDropzone"
      ref="fileInput"
      :options="dropzoneOptions"
      @vdropzone-file-added="setFiles"
      @vdropzone-removed-file="setFiles"
    />
  </b-modal>
</template>


<script>
import modalMixin from './mixin'
import Vue2Dropzone from "vue2-dropzone";
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "UploadModal",
  components: {
    Vue2Dropzone,
  },
  mixins: [
    modalMixin
  ],
  data: () => ({
    files: [],
    submitting: false,
    error: '',
    dropzoneOptions: {
      url: 'http',
      autoProcessQueue: false,
      addRemoveLinks: true,
      createImageThumbnails: false,
      dictDefaultMessage: 'Drag & Drop your files or <a href="#" onclick="event.preventDefault()">Browse</a>',
      maxFilesize: 1000,
    },
  }),
  methods: {
    ...mapActions(['uploadFiles']),
    async ok(event) {
      event.preventDefault();
      this.submitting = true;
      this.error = '';

      try {
        await this.uploadFiles({ files: this.files });
        this.$refs.fileInput.removeAllFiles(true);
        this.$refs.modal.hide();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.submitting = false;
      }
    },
    setFiles () {
      this.$nextTick(() => {
        this.files = this.$refs.fileInput ? this.$refs.fileInput.getAcceptedFiles() : []
      })
    },
    onModalShown() {
      this.$root.$emit('upload-modal-shown');
    },
    onModalHidden() {
      this.$root.$emit('upload-modal-hidden');
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep #uploadDropzone .dz-progress {
  display: none;
}

::v-deep .dz-preview .dz-image > img {
  width: 100%;
  max-height: 300px;
}
</style>
